import { createFinancialAidLeadAssistant } from '@quero/qb-partials/src/javascripts/components/financial_aid_lead_assistant';

createFinancialAidLeadAssistant();
